/**
 * Messages in the playfield (spec 08 §2): ROUND nn / READY !, HURRY UP !, PLAYER n GETS EXTEND,
 * GAME OVER, and the title's lines - where the C64 put them, drawn on the HUD canvas in the game font.
 */

import { drawText, textWidth } from '../font8';

export interface Banner {
  lines: readonly string[];
  colour: string;
  /** Font pixels per pixel. */
  scale?: number;
  /** Base-unit y of the first line's top; the lines follow 12 font pixels apart. */
  y: number;
}

/** Draw banners centred on the playfield (x = 320 in the 640-wide HUD), with a dark shadow. */
export function drawBanners(ctx: CanvasRenderingContext2D, banners: readonly Banner[], shadow: string): void {
  for (const b of banners) {
    const s = b.scale ?? 1;
    b.lines.forEach((line, i) => {
      const x = Math.round(320 - textWidth(line, s) / 2);
      const y = Math.round(b.y + i * 12 * s);
      drawText(ctx, line, x + s, y + s, shadow, s);
      drawText(ctx, line, x, y, b.colour, s);
    });
  }
}
